import React from 'react';
import { useSelector } from 'react-redux';

import { SubnodeOutlined } from '@ant-design/icons';

import { Dropdown, Menu } from 'antd';

import RibbonButton from 'common/components/button/RibbonButton';

import gridSelector from 'common/components/grid-view/controllers/selectors';

import MoveGlnToMember from './MoveGlnToMember';
import MoveAllToMember from 'pages/home/ribbon/components/sections/shared/MoveAllToMember';

import {
  MoveAllEntitiesToMemberModal,
  ReassignGLNToMemberModal,
} from 'common/components/modal';

import * as memberServices from 'services/members';
import { useCheckIsSuperAdmin } from 'hooks';

const MemberActions = () => {
  const defaultProductParams = {
    searchText: '',
  };

  const selectedItemDetailList = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );

  const firstSelectedMemberItem = selectedItemDetailList?.[0];

  const isSuperAdmin = useCheckIsSuperAdmin();

  const menuOptions = (
    <Menu>
      <Menu.Item key='move-all'>
        <MoveAllToMember
          disabled={selectedItemDetailList?.length !== 1 || !isSuperAdmin}
          selectedMember={selectedItemDetailList?.[0]}
        />
      </Menu.Item>

      <Menu.Item key='move-gln'>
        <MoveGlnToMember entityType='MEM' />
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Dropdown overlay={menuOptions} placement='bottomLeft' arrow>
        <RibbonButton icon={<SubnodeOutlined />} label='Member Actions' />
      </Dropdown>
      <MoveAllEntitiesToMemberModal
        isMultiple={false}
        dataPath='data.allMembers'
        params={{ searchText: '' }}
        mapSearch={(searchText) => ({ searchText })}
        tagRender={{ value: (itemData) => itemData?.companyName }}
        itemIdName='companyId'
        originMember={selectedItemDetailList?.[0]}
      />

      <ReassignGLNToMemberModal
        title='Assign GLN(s) to Member'
        isMultiple={false}
        service={memberServices.getAllMemberForReassign}
        dataPath='data.allMembers'
        params={defaultProductParams}
        mapSearch={(searchText) => ({ searchText })}
        tagRender={{ value: (itemData) => itemData?.companyName }}
        itemIdName='companyId'
        glnList={firstSelectedMemberItem?.glns}
        memberId={firstSelectedMemberItem?.id}
      />
    </>
  );
};

export default MemberActions;
